import { CommonProps } from '@repo/types'
import { observer } from 'mobx-react-lite'

export const Section = observer(function Section({ children }: CommonProps) {
  return <section className='border-b border-b-shade-3 py-6'>{children}</section>
})
